import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  // Main Masai Cables product categories
  const cableProducts = [
    { name: 'WIRES & CABLES', image: '/images/products/wires-cables.jpg' },
    { name: 'WELDING CABLE', image: '/images/products/welding-cable.jpg' },
    { name: 'DOMESTIC CABLES', image: '/images/products/domestic-cables.jpg' },
    { name: 'SUBMERSIBLE CABLES', image: '/images/products/submersible-cables.jpg' },
    { name: 'OVERHEAD CONDUCTORS', image: '/images/products/overhead-conductors.jpg' },
    { name: 'FLEXIBLE CABLES', image: '/images/products/flexible-cables.jpg' },
    { name: 'ARMOURED CABLE', image: '/images/products/armoured-cable.jpg' },
  ];

  // Versil Pumps products
  const pumpProducts = [
    { name: 'SUBMERSIBLE PUMPS', image: '/images/products/submersible-pump.jpg', description: 'Borehole & deep well' },
    { name: 'MONO BLOCK PUMPS', image: '/images/products/monoblock-pump.jpg', description: 'Surface & domestic' },
    { name: 'SOLAR PUMPS', image: '/images/products/solar-pump.jpg', description: 'Solar-powered solutions' },
    { name: 'CENTRIFUGAL PUMPS', image: '/images/products/centrifugal-pump.jpg', description: 'Industrial applications' },
    { name: 'OPEN WELL PUMPS', image: '/images/products/openwell-pump.jpg', description: 'Wells & reservoirs' },
    { name: 'PUMP MOTORS', image: '/images/products/pump-motor.jpg', description: 'Stainless steel motors' },
    { name: 'COLUMN PIPES', image: '/images/products/column-pipe.jpg', description: 'UPVC rising mains' },
    { name: 'CONTROL PANELS', image: '/images/products/control-panel.jpg', description: 'Pump controllers' },
  ];

  // Masai Rolling Mills products
  const steelProducts = [
    { name: 'TMT STEEL BARS', image: '/images/products/tmt-bars.jpg', description: 'Construction grade' },
    { name: 'STEEL BILLETS', image: '/images/products/steel-billets.jpg', description: 'For re-rolling' },
    { name: 'DEFORMED BARS', image: '/images/products/deformed-bars.jpg', description: 'High tensile strength' },
    { name: 'PLAIN ROUND BARS', image: '/images/products/plain-bars.jpg', description: 'General fabrication' },
  ];

  return (
    <div>
      {/* Hero Section - Updated for MasaiLink */}
      <section className="hero masailink-hero">
        <div className="container">
          <span className="hero-badge">AUTHORIZED DISTRIBUTOR</span>
          <h1>MasaiLink</h1>
          <p className="hero-subtitle">Your Link to Masai Group Quality</p>
          <div className="hero-logos">
            <span className="brand-tag">Masai Cables</span>
            <span className="brand-tag">Versil Pumps</span>
            <span className="brand-tag">Masai Rolling Mills</span>
          </div>
          <p className="hero-description">Genuine products • Factory-direct pricing • Technical expertise</p>
          <div className="hero-buttons">
            <Link to="/products" className="btn btn-primary">View All Products</Link>
            <Link to="/contact" className="btn btn-outline">Request Quote</Link>
          </div>
        </div>
      </section>

      {/* Trust Badges */}
      <section className="trust-badges">
        <div className="container">
          <div className="badges-grid">
            <div className="badge">
              <span className="badge-icon">✓</span>
              <div>
                <strong>100% Genuine</strong>
                <small>Direct from Masai factories</small>
              </div>
            </div>
            <div className="badge">
              <span className="badge-icon">✓</span>
              <div>
                <strong>KEBS Approved</strong>
                <small>All products certified</small>
              </div>
            </div>
            <div className="badge">
              <span className="badge-icon">✓</span>
              <div>
                <strong>Bulk Pricing</strong>
                <small>Contractor rates available</small>
              </div>
            </div>
            <div className="badge">
              <span className="badge-icon">✓</span>
              <div>
                <strong>Nairobi Delivery</strong>
                <small>Fast & reliable</small>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction - Updated for MasaiLink */}
      <section className="intro">
        <div className="container">
          <h2>Welcome to MasaiLink</h2>
          <p className="intro-text">We are proud <strong>authorized distributors</strong> for the entire Masai Group of Companies, bringing you Kenya's most trusted industrial products through a single, reliable source.</p>
          
          <div className="company-showcase">
            <div className="company-card">
              <img src="/images/logos/masai-cables.png" alt="Masai Cables" className="company-logo" />
              <h3>Masai Cables Ltd</h3>
              <p>Premium quality wires & cables for power, construction, and industrial applications.</p>
              <Link to="/cables" className="company-link">Browse Cables →</Link>
            </div>
            
            <div className="company-card">
              <img src="/images/logos/versil-pumps.png" alt="Versil Pumps" className="company-logo" />
              <h3>Masai Store Ltd</h3>
              <p>Sole importers of Versil pumps - submersible, mono block, and solar water solutions.</p>
              <Link to="/pumps" className="company-link">Browse Pumps →</Link>
            </div>
            
            <div className="company-card">
              <img src="/images/logos/masai-rolling.png" alt="Masai Rolling Mills" className="company-logo" />
              <h3>Masai Rolling Mills</h3>
              <p>Quality TMT steel bars and billets for construction and manufacturing.</p>
              <Link to="/steel" className="company-link">Browse Steel →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>160 MT</h3>
              <p>Copper Capacity</p>
            </div>
            <div className="stat-item">
              <h3>200 MT</h3>
              <p>Aluminium Capacity</p>
            </div>
            <div className="stat-item">
              <h3>50+</h3>
              <p>Pump Models</p>
            </div>
            <div className="stat-item">
              <h3>ISO 9001</h3>
              <p>2015 Certified</p>
            </div>
          </div>
        </div>
      </section>

      {/* Cable Products Section */}
      <section className="products-section">
        <div className="container">
          <h2>Masai Cables</h2>
          <p className="section-subtitle">Kenya's premier cable manufacturer</p>
          
          <div className="products-grid">
            {cableProducts.map((product, index) => (
              <div key={index} className="product-card">
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <h3>{product.name}</h3>
                <Link to="/catalogue" className="btn btn-small">View Details</Link>
              </div>
            ))}
          </div>
          
          <div className="view-all-container">
            <Link to="/cables" className="btn btn-secondary">View All Cables</Link>
          </div>
        </div>
      </section>

      {/* Pumps Section */}
      <section className="products-section pumps-section">
        <div className="container">
          <h2>Versil Pumps</h2>
          <p className="section-subtitle">Premium pumps for water solutions - from Masai Store Ltd</p>
          
          <div className="products-grid">
            {pumpProducts.map((product, index) => (
              <div key={index} className="product-card">
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <h3>{product.name}</h3>
                <p className="product-desc">{product.description}</p>
                <Link to="/pumps" className="btn btn-small">View Details</Link>
              </div>
            ))}
          </div>
          
          <div className="view-all-container">
            <Link to="/pumps" className="btn btn-secondary">View All Pumps</Link>
          </div>
        </div>
      </section>

      {/* Steel Section */}
      <section className="products-section steel-section">
        <div className="container">
          <h2>Masai Rolling Mills</h2>
          <p className="section-subtitle">Quality TMT steel for construction</p>
          
          <div className="products-grid">
            {steelProducts.map((product, index) => (
              <div key={index} className="product-card">
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <h3>{product.name}</h3>
                <p className="product-desc">{product.description}</p>
                <Link to="/steel" className="btn btn-small">View Details</Link>
              </div>
            ))}
          </div>
          
          <div className="view-all-container">
            <Link to="/steel" className="btn btn-secondary">View All Steel</Link>
          </div>
        </div>
      </section>

      {/* Project Solutions Section */}
      <section className="solutions-section">
        <div className="container">
          <h2>Complete Project Solutions</h2>
          <p className="section-subtitle">Everything you need for your project - from one source</p>
          
          <div className="solutions-grid">
            <div className="solution-card">
              <div className="solution-icon">💧</div>
              <h3>Borehole Installation</h3>
              <ul>
                <li>✓ Versil submersible pump</li>
                <li>✓ Masai submersible cable</li>
                <li>✓ UPVC rising main</li>
                <li>✓ Control panel</li>
              </ul>
              <Link to="/contact" className="btn-small">Get Quote</Link>
            </div>
            
            <div className="solution-card">
              <div className="solution-icon">🏗️</div>
              <h3>Building Construction</h3>
              <ul>
                <li>✓ TMT steel reinforcement</li>
                <li>✓ Domestic wiring cables</li>
                <li>✓ Armoured main cables</li>
                <li>✓ Water supply pumps</li>
              </ul>
              <Link to="/contact" className="btn-small">Get Quote</Link>
            </div>
            
            <div className="solution-card">
              <div className="solution-icon">🌞</div>
              <h3>Solar Water Systems</h3>
              <ul>
                <li>✓ Solar submersible pump</li>
                <li>✓ Solar cables</li>
                <li>✓ Solar panels</li>
                <li>✓ Complete installation</li>
              </ul>
              <Link to="/contact" className="btn-small">Get Quote</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose MasaiLink */}
      <section className="why-choose">
        <div className="container">
          <h2>Why Choose MasaiLink?</h2>
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">🏭</div>
              <h3>Direct Factory Access</h3>
              <p>We source directly from Masai factories - no middlemen, better prices</p>
            </div>
            <div className="feature">
              <div className="feature-icon">✓</div>
              <h3>Genuine Products</h3>
              <p>100% authentic Masai Cables, Versil Pumps, and MRM steel</p>
            </div>
            <div className="feature">
              <div className="feature-icon">📋</div>
              <h3>Technical Expertise</h3>
              <p>Get the right product for your specific application</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🚚</div>
              <h3>Reliable Delivery</h3>
              <p>Fast delivery to Nairobi, Kajiado, and surrounding areas</p>
            </div>
          </div>
        </div>
      </section>

      {/* Complete Cable Range */}
      <section className="categories-showcase">
        <div className="container">
          <h2>Complete Cable Range</h2>
          <p className="section-subtitle">From Masai Cables - all types and sizes available</p>
          <div className="categories-grid">
            <div className="category-card">
              <img src="/images/products/copper-single.jpg" alt="Copper Cables" />
              <div className="category-overlay">
                <h3>Copper Cables</h3>
                <p>Single, 2, 3 & 4 Core</p>
              </div>
            </div>
            <div className="category-card">
              <img src="/images/products/aluminium-single.jpg" alt="Aluminium Cables" />
              <div className="category-overlay">
                <h3>Aluminium Cables</h3>
                <p>Single, 2, 3 & 4 Core</p>
              </div>
            </div>
            <div className="category-card">
              <img src="/images/products/armoured-cable.jpg" alt="Armoured Cables" />
              <div className="category-overlay">
                <h3>Armoured Cables</h3>
                <p>SWA, STA, AWA</p>
              </div>
            </div>
            <div className="category-card">
              <img src="/images/products/flexible-cables.jpg" alt="Flexible Cables" />
              <div className="category-overlay">
                <h3>Flexible Cables</h3>
                <p>0.5mm² to 630mm²</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Ready to start your project?</h2>
          <p>Contact MasaiLink today for genuine Masai products at factory-direct prices</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-light">Request Quote</Link>
            <a href="https://wa.me/254700241467" className="btn btn-whatsapp">WhatsApp Us</a>
          </div>
          <p className="cta-note">We reply within 1 hour</p>
        </div>
      </section>
    </div>
  );
};

export default Home;